import {
    Flex,
    Text,
} from "@chakra-ui/react";
import "../../src/App.css";
import {
    FastForward,
    ChevronRight,
    Rocket,
} from "lucide-react";

import {
    useRef,
    useState,
} from "react";

const QuickLinks = ({
    links = [],
}) => {
    const [order, setOrder] = useState(
        links.map((_, index) => index)
    );

    const [dragX, setDragX] =
        useState(0);

    const [isDragging, setIsDragging] =
        useState(false);

    const startX =
        useRef(0);

    const hasDragged =
        useRef(false);

    if (!links.length) {
        return null;
    }

    const handlePointerDown = (
        event
    ) => {
        startX.current =
            event.clientX;

        hasDragged.current =
            false;

        setIsDragging(true);

        event.currentTarget.setPointerCapture(
            event.pointerId
        );
    };

    const handlePointerMove = (
        event
    ) => {
        if (!isDragging) {
            return;
        }

        const distance =
            event.clientX -
            startX.current;

        if (
            Math.abs(distance) > 5
        ) {
            hasDragged.current =
                true;
        }

        setDragX(distance);
    };

    const handlePointerUp = () => {
        if (!isDragging) {
            return;
        }

        setIsDragging(false);

        const threshold = 100;

        if (
            Math.abs(dragX) >
            threshold
        ) {
            setOrder(
                current => [
                    ...current.slice(1),
                    current[0],
                ]
            );
        }

        setDragX(0);
    };

    const handleClick = (
        link
    ) => {
        if (
            hasDragged.current
        ) {
            hasDragged.current =
                false;

            return;
        }

        link.onClick?.();
    };

    return (
        <Flex
            mt={6}
            direction={{
                base: "column",
                md: "row",
            }}
            align={{
                base: "flex-start",
                md: "center",
            }}
            gap={{
                base: 3,
                md: 5,
            }}
            w="100%"
        >
            {/* QUICK ACTIONS TITLE */}
            <Flex
                align="center"
                gap={2}
                pr={{
                    base: 0,
                    md: 5,
                }}
                pb={{
                    base: 0,
                    md: 0,
                }}
                borderRight={{
                    base: "none",
                    md: "1px solid",
                }}
                borderColor="gray.200"
                flexShrink={0}
            >
                <Rocket
                    size={17}

                    color="#2453FF"
                    //                 style={{
                    //     animation:
                    //         "rocketLaunch 1.2s ease-in-out infinite",
                    // }}
                />

                <Text
                    fontSize="18px"
                    fontWeight="600"
                    color="#2453FF"
                    whiteSpace="nowrap"
                >
                    Quick Access
                </Text>
            </Flex>

            {/* HORIZONTAL STACK */}
            <Flex
              position="relative"
    h={{
        base: "62px",
        md: "70px",
    }}
    w={{
        base: "100%",
        sm: "370px",
        md: "500px",
    }}
    px={{
        base: 4,
        sm: 0,
        md: 0,
    }}
    boxSizing="border-box"
                maxW="100%"
                flexShrink={0}
                align="center"
                overflow="visible"
            >
                {order
                    .slice()
                    .reverse()
                    .map(
                        (
                            linkIndex,
                            reversedIndex
                        ) => {
                            const link =
                                links[
                                    linkIndex
                                ];

                            const position =
                                order.length -
                                1 -
                                reversedIndex;

                            const isTop =
                                position ===
                                0;

                            const offset =
                                    position * 37;

                                const mobileOffset =
                                    position * 3;

                                const scale =
                                    1 -
                                    position * 0.025;

                            return (
                                <Flex
                                    key={
                                        link.id
                                    }
                                    position="absolute"
                                    top="50%"
                                    right={{
                                        base: mobileOffset,
                                        sm: offset,
                                    }}
                                   w={{
                                        base: "100%",
                                        sm: "330px",
                                        md: "430px",
                                    }}
                                    maxW={{
                                        base: "430px",
                                        md: "430px",
                                    }}
                                    h={{
                                        base: "58px",
                                        md: "66px",
                                    }}
                                    px={{
                                        base: 3,
                                        md: 4,
                                    }}
                                    align="center"
                                    justify="space-between"
                                    gap={3}
                                    bg="white"
                                    border="1px solid"
                                    borderColor="gray.200"
                                    borderLeft="3px solid"
                                    borderLeftColor="#2453FF"
                                    borderRadius="12px"
                                    boxShadow={
                                        isTop
                                            ? "0 5px 16px rgba(15, 23, 42, 0.10)"
                                            : "0 2px 8px rgba(15, 23, 42, 0.06)"
                                    }
                                    transform={
                                        isTop
                                            ? `translate(${dragX}px, -50%) scale(${scale})`
                                            : `translate(0, -50%) scale(${scale})`
                                    }
                                    zIndex={
                                        100 -
                                        position
                                    }
                                    cursor={
                                        isTop
                                            ? "grab"
                                            : "default"
                                    }
                                    userSelect="none"
                                    touchAction="pan-y"
                                    transition={
                                        isDragging &&
                                        isTop
                                            ? "none"
                                            : "transform 0.25s ease, box-shadow 0.25s ease"
                                    }
                                    onPointerDown={
                                        isTop
                                            ? handlePointerDown
                                            : undefined
                                    }
                                    onPointerMove={
                                        isTop
                                            ? handlePointerMove
                                            : undefined
                                    }
                                    onPointerUp={
                                        isTop
                                            ? handlePointerUp
                                            : undefined
                                    }
                                    onPointerCancel={
                                        isTop
                                            ? handlePointerUp
                                            : undefined
                                    }
                                    onClick={
                                        isTop
                                            ? () =>
                                                  handleClick(
                                                      link
                                                  )
                                            : undefined
                                    }
                                >
                                    <Flex
                                        align="center"
                                        gap={3}
                                        minW={0}
                                    >
                                        <Flex
                                            w={{
                                                base: "40px",
                                                md: "44px",
                                            }}
                                            h={{
                                                base: "40px",
                                                md: "44px",
                                            }}
                                            borderRadius="10px"
                                            bg="#EEF3FF"
                                            align="center"
                                            justify="center"
                                            flexShrink={0}
                                        >
                                            {
                                                link.icon
                                            }
                                        </Flex>

                                        <Text
                                            fontSize={{
                                                base: "sm",
                                                md: "md",
                                            }}
                                            fontWeight="600"
                                            color="#071D54"
                                            whiteSpace="nowrap"
                                            overflow="hidden"
                                            textOverflow="ellipsis"
                                        >
                                            {
                                                link.title
                                            }
                                        </Text>
                                    </Flex>

                                    <ChevronRight
                                        size={21}
                                        color="#2453FF"
                                        flexShrink={0}
                                    />
                                </Flex>
                            );
                        }
                    )}
            </Flex>
        </Flex>
    );
};

export default QuickLinks;